import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./WasteLog.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dropdown,
  InputField,
  Modal,
  SearchInput,
  TextComponent,
} from "../../../../components";
import { SubmitButton } from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import ModalLeft from "../../../../components/ModalLeft/ModalLeft";
import { ReactComponent as MinusIcon } from "../../../../assets/images/minusIcon.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/images/plusIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";
const WasteLog = () => {
  const navigate = useNavigate();
  const [addModal, setaddModal] = useState(false);
  const [EditModal, setEditModal] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  const [quantity, setquantity] = useState(2);
  const [name, setname] = useState("");
  const [reason, setReason] = useState();
  const [category, setcategory] = useState();
  const [itemId, setItemId] = useState("");

  const categories = [
    {
      value: "Ingredient",
      role: "Ingredient",
      id: 1,
    },
    {
      value: "Component",
      role: "Component",
      id: 2,
    },
    {
      value: "Material",
      role: "Material",
      id: 3,
    },
  ];

  const reasons = [
    {
      value: "Burnt",

      id: 1,
    },
    {
      value: "Spoil",
      id: 2,
    },
  ];
  const columns = [
    {
      title: "Task ID",
      dataIndex: "ItemID",
      key: "ItemID",
    },
    {
      title: "Task Name",
      dataIndex: "ItemName",
      key: "ItemName",
    },
    {
      title: "Category",
      dataIndex: "Category",
      key: "Category",
    },
    {
      title: "Quantity",
      key: "Quantity",
      dataIndex: "Quantity",
    },
    {
      title: "Waste",
      key: "Waste",
      dataIndex: "Waste",
    },
    {
      title: "Recorded",
      key: "Recorded",
      dataIndex: "Recorded",
    },

    {
      title: "Actions",
      key: "Actions",
      dataIndex: "Actions",
      render: (text, record) => record.Actions,
    },
  ];

  const data = [
    {
      ItemID: "001",
      ItemName: "Croissant",
      Category: "Pastry",
      Quantity: "12 pcs",
      Waste: "Burnt during baking",
      Recorded: "John Doe",
      Actions: [
        <div className={styles.itemsButtonDiv}>
          <DeleteIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
          <EditIcon
            className={styles.itemsButton}
            onClick={() => setEditModal(true)}
          />
        </div>,
      ],
    },
    {
      ItemID: "002",
      ItemName: "Chocolate ",
      Category: "Cake",
      Quantity: "1 whole",
      Waste: "Expired",
      Recorded: "Sarah Khan",
      Actions: [
        <div className={styles.itemsButtonDiv}>
          <DeleteIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
          <EditIcon
            className={styles.itemsButton}
            onClick={() => setEditModal(true)}
          />
        </div>,
      ],
    },
  ];

  const handleDisplayFilter = () => {
    setShowFilter(true);
  };

  const [ReasonFilter, setReasonFilter] = useState({
    value: "Brunt",
    id: 1,
  });

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        showFilterIcon={true}
        onClickFilter={() => handleDisplayFilter()}
        heading={"Waste Log"}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => setaddModal(true)}
        submitButtonText={"Add Waste Entry"}
        // showBackIcon={true}
        // showFilterIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />

      {/* Table Section */}
      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>
      <ModalLeft
        open={addModal}
        onCancel={() => setaddModal(false)}
        className={styles.modalCont}
        title={"Add Waste Entry"}
        buttonTitle={"save"}
        onBtnPress={() => setaddModal(false)}
        btnStyle={{ marginTop: "20px", width: "50%" }}
      >
        <div className={styles.modalContent}>
          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Item Category"} />
            <div className={styles.search_div}>
              <Dropdown
                value={category}
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                options={categories}
                onChange={(e) => setcategory(e)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Item Name"} />
            <div className={styles.search_div}>
              <SearchInput
                placeholder="Chocolate Muffin"
                rightIcon={<SearchOutlined />}
                className={styles.searchInput}
                value={name}
                onChange={(e) => setname(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Item ID"} />
            <div className={styles.search_div}>
              <SearchInput
                placeholder="001"
                rightIcon={<SearchOutlined />}
                className={styles.searchInput}
                value={itemId}
                onChange={(e) => setItemId(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent
              className={styles.itemName}
              text={"Quantity Changed"}
            />
            <div className={styles.itemControls}>
              <MinusIcon
                className={styles.Controls}
                onClick={() => {
                  quantity >= 1 && setquantity(quantity - 1);
                }}
              />
              <TextComponent className={styles.ControlsText} text={quantity} />
              <PlusIcon
                className={styles.Controls}
                onClick={() => setquantity(quantity + 1)}
              />
            </div>
          </div>
          <div className={styles.itemRow}>
            <TextComponent
              className={styles.itemName}
              text={"Reason for Waste"}
            />
            <div className={styles.search_div}>
              <Dropdown
                value={reason}
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                options={reasons}
                onChange={(e) => setReason(e)}
              />
            </div>
          </div>
        </div>
      </ModalLeft>

      <ModalLeft
        open={EditModal}
        onCancel={() => setEditModal(false)}
        className={styles.modalCont}
        title={"Edit Waste Entry"}
        buttonTitle={"save"}
        onBtnPress={() => setEditModal(false)}
        btnStyle={{ marginTop: "20px", width: "50%" }}
      >
        <div className={styles.modalContent}>
          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Item Category"} />
            <div className={styles.search_div}>
              <Dropdown
                value={category}
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                options={categories}
                onChange={(e) => setcategory(e)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Item Name"} />
            <div className={styles.search_div}>
              <SearchInput
                placeholder="Chocolate Muffin"
                rightIcon={<SearchOutlined />}
                className={styles.searchInput}
                value={name}
                onChange={(e) => setname(e.target.value)}
              />
            </div>
          </div>
          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Item ID"} />
            <div className={styles.search_div}>
              <SearchInput
                placeholder="001"
                rightIcon={<SearchOutlined />}
                className={styles.searchInput}
                value={itemId}
                onChange={(e) => setItemId(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent
              className={styles.itemName}
              text={"Quantity Changed"}
            />
            <div className={styles.itemControls}>
              <MinusIcon
                className={styles.Controls}
                onClick={() => {
                  quantity >= 1 && setquantity(quantity - 1);
                }}
              />
              <TextComponent className={styles.ControlsText} text={quantity} />
              <PlusIcon
                className={styles.Controls}
                onClick={() => setquantity(quantity + 1)}
              />
            </div>
          </div>
          <div className={styles.itemRow}>
            <TextComponent
              className={styles.itemName}
              text={"Reason for Waste"}
            />
            <div className={styles.search_div}>
              <Dropdown
                value={reason}
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                options={reasons}
                onChange={(e) => setReason(e)}
              />
            </div>
          </div>
        </div>
      </ModalLeft>

      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        onClickCancelButton={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Delete"}
        headingClass={styles.modalHeading}
        width={"400px"}
        twoButton
        okBtnTitle={"Delete"}
        cancelBtnTitle={"Cancel"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        onBtnPress={() => setIsModal(false)}
      >
        <div>
          <TextComponent
            text="Are you sure you want to Delete? "
            className={styles.CardText}
          />
        </div>
      </Modal>

      {/* Filter Modal  */}

      <Modal
        open={showFilter}
        onClickOkButton={() => {
          setShowFilter(false);
        }}
        onCancel={() => setShowFilter(false)}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setShowFilter(false)}
        onClickCancelButton={() => setShowFilter(false)}
        okBtnTitle={"Apply Filters"}
        cancelBtnTitle={"Reset All"}
      >
        <Dropdown
          className={styles.input}
          label={"Reason"}
          labelClass={styles.labelClass}
          value={ReasonFilter}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Brunt",
              id: 1,
            },
            {
              value: "Expired",
              id: 2,
            },
            {
              value: "Spoilt",
              id: 3,
            },

            {
              value: "Expired",
              id: 4,
            },
          ]}
          onChange={(e) => setReasonFilter(e)}
        />
      </Modal>
    </div>
  );
};

export default WasteLog;
